import createAction from 'redux-actions/es/createAction';

export const sendMessageRequest = createAction('SEND_MESSAGE_REQUEST');
export const sendMessageSuccess = createAction('SEND_MESSAGE_SUCCESS');
export const sendMessageFail = createAction('SEND_MESSAGE_FAIL');

export const getContactInfoRequest = createAction('GET_CONTACT_INFO_REQUEST');
export const getContactInfoSuccess = createAction('GET_CONTACT_INFO_SUCCESS');
export const getContactInfoFail = createAction('GET_CONTACT_INFO_FAIL');
